export const HomePageExplore = [
    {
        tag: 'Free',
        courses: [
            {
                heading: 'Learn HTML',
                desciption: 'This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Learn CSS',
                desciption: 'Learn CSS This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques Beginner 6 Lessons',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Responsive Web course',
                desciption: 'This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes',
                level: 'Begineer',
                lessonNumber: 6,  
            },
        ]
    },
    {
        tag: 'New to Coding',
        courses: [
            {
                heading: 'Learn HTML',
                desciption: 'This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Learn CSS',
                desciption: 'Learn CSS This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques Beginner 6 Lessons',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Responsive Web course',
                desciption: 'This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes',
                level: 'Begineer',
                lessonNumber: 6,  
            },
        ]
    },
    {
        tag: 'Most Popular',
        courses: [
            {
                heading: 'Java',
                desciption: 'This is a course to learn html in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'DSA',
                desciption: 'This is a course to learn css in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'JavaScript',
                desciption: 'This is a course to learn web development in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
        ]
    },
    {
        tag: 'Skill Paths',
        courses: [
            {
                heading: 'Flask',
                desciption: 'This is a course to learn html in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Django',
                desciption: 'This is a course to learn css in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Fast API',
                desciption: 'This is a course to learn web development in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
        ]
    },
    {
        tag: 'Career Paths',
        courses: [
            {
                heading: 'Next.js',
                desciption: 'This is a course to learn html in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Nuxt.js',
                desciption: 'This is a course to learn css in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
            {
                heading: 'Sanity',
                desciption: 'This is a course to learn web development in a very simple and easy fashion.',
                level: 'Begineer',
                lessonNumber: 6,  
            },
        ]
    },
]